// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".billing-container hr {\n  margin: 0 !important;\n}\n.billing-container h4 {\n  margin: 0 !important;\n}\n.billing-container .padding-28 {\n  padding: 28px;\n}\n.billing-container .margin-top-0 {\n  margin-top: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
